import React, { useState } from "react"
import { Box } from "theme-ui"
import { useBreakpointIndex } from "@theme-ui/match-media"
import Modal from "components/modal"
import Slideshow from "components/slideshow"
function Gallery({ data, minWidth }) {
    const breakpointIndex = useBreakpointIndex()
    const [open, setOpen] = useState(false)
    const [slideIndex, setSlideIndex] = useState(0)

    const openFromImage = (index) => {
        setSlideIndex(index)
        showModal()
    }
    const showModal = () => {
        setOpen(true)
    }

    const hideModal = () => {
        setOpen(false)
    }
    return (
        <>
            {/* <Flex sx={{justifyContent: 'flex-end'}}>
            <Button variant="small" onClick={showModal}>
                <Flex sx={{alignItems:'center'}}>
                    <Box sx={{mr:1}} className={componentStyles.iconsMedium} ><MdSlideshow /></Box> Image Slideshow
               </Flex>
            </Button>
        </Flex> */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    pt: 4,
                    columnGap: 2,
                    rowGap: 3,
                }}
            >
                {data.map((obj, index) => {
                    return (
                        <Box
                            key={index}
                            onClick={(e) => openFromImage(index)}
                            sx={{
                                flex:
                                    breakpointIndex < 4 ? "0 0 40" : "0 0 30%",
                                mb: 4,
                                mx: 2,
                                textAlign: "center",
                                minWidth: minWidth ? minWidth : "0%",
                            }}
                        >
                            <img
                                src={obj.media.publicURL}
                                alt={obj.alternativeText}
                            />
                            {/* <div>{obj.title}</div> */}
                        </Box>
                    )
                })}
            </Box>
            {/* <Modal show={open} handleClose={hideModal}>
                <Slideshow data={data} initialSlide={slideIndex} />
            </Modal> */}
        </>
    )
}

export default Gallery
